<template>
  <div class="childPannel">
    <div v-if="list.length" class="childPannel-box">
      <div v-for="(m, i) in list" :key="i" class="childPannel-box-item" @click="handleClickItem(m)">
        <div class="childPannel-box-item-block">
          <div class="childPannel-box-item-block-info">
            <span class="childPannel-box-item-block-info-label">名称：</span>
            <span class="childPannel-box-item-block-info-value">{{ m.name }}</span>
          </div>
        </div>
      </div>
    </div>

    <el-empty v-if="!list.length" :image-size="100" description="当前内容为空" />
    <el-pagination
      class="childPannel-pagination"
      v-else
      size="small"
      v-model:current-page="params.pageNum"
      :page-size="params.pageSize"
      background
      :pager-count="5"
      @change="getList"
      layout="prev, pager, next"
      :total="total"
    />
  </div>
</template>

<script lang="ts" setup>
import { watch, reactive, ref } from 'vue'
import { toCameraPosition } from './utils'
import { Search } from '@element-plus/icons-vue'
import { LayerPopupCtrl } from '@/components/LayerPopupCtrl'
import { Cartographic, Math } from 'cesium'
import { CesiumObj } from '@/components/GIS/CesiumObj'
import RescuPopup from '../../Popup/RescuPopup.vue'
import { getaisDataInfo } from '@/apiFzn'
import type { IrescueInfo } from '@/apiFzn/types'

import { useRescueStore } from '@/stores/rescue'
const userResStore = useRescueStore()

const popupCtrl = LayerPopupCtrl.getInstance();
let cesiumobj: CesiumObj | null = null

const props = defineProps({
  showPannelKey: {
    type: String,
    default: '',
  },
  searchValue: {
    type: String,
    default: '', // 提供默认值
  },
})
const handleClickItem = async (m: IrescueInfo) => {
  if (!cesiumobj) cesiumobj = await CesiumObj.getInstance()
  // userResStore.openRescueDetail(m.id)

  popupCtrl.popupMap.forEach((val) => {
    val.destroy()
  })
  toCameraPosition({
    lng: m.longitude,
    lat: m.latitude,
  })
  const cartographic = Cartographic.fromDegrees(m.longitude, m.latitude, 0)
  popupCtrl.popup({
    viewer: cesiumobj.viewer,
    id: m.id,
    lnglat: [cartographic.longitude, cartographic.latitude].map(Math.toDegrees) as [number, number],
    Com: RescuPopup,
    properties: m,
  })
}

const list = ref<IrescueInfo[]>([])
const total = ref(0)

const params = reactive({
  name: '',
  pageNum: 1,
  pageSize: 8,
})
const getList = () => {
  getaisDataInfo(params).then((res) => {
    list.value = res.rows
    total.value = res.total
  })
}
defineExpose({
  getList,
})

watch(
  () => props.searchValue,
  (newVal) => {
    params.name = newVal
    params.pageNum = 1
  },
  { immediate: true }
)
</script>

<style lang="scss" scoped>
@import url('./childPannel.scss');
</style>
